"use client";

import { useEffect } from "react";

/**
 * Syncs `--nav-mobile-top` / `--nav-mobile-bottom` to measured fixed bar
 * heights so the menu shutter anchors under the top bar on the viewport.
 */
export default function useNavHeights(
  topRef: React.RefObject<HTMLElement | null>,
  bottomRef: React.RefObject<HTMLElement | null>
) {
  useEffect(() => {
    const topEl = topRef.current;
    const bottomEl = bottomRef.current;
    if (!topEl || !bottomEl) return;

    const sync = () => {
      document.documentElement.style.setProperty(
        "--nav-mobile-top",
        `${topEl.getBoundingClientRect().height}px`
      );
      document.documentElement.style.setProperty(
        "--nav-mobile-bottom",
        `${bottomEl.getBoundingClientRect().height}px`
      );
    };

    sync();
    const ro = new ResizeObserver(sync);
    ro.observe(topEl);
    ro.observe(bottomEl);
    window.addEventListener("resize", sync);

    return () => {
      ro.disconnect();
      window.removeEventListener("resize", sync);
    };
  }, [topRef, bottomRef]);
}
